module.exports = __webpack_public_path__ + "img/banner_img_icon_1.194fbfba.png";